export default {
  record_video_label: 'Grabar Vídeo',
  upload_video_label: 'Subir Vídeo',
  submit: 'Entregar',
  upload_in_progess: 'Espere mientras su video se carga. Esto puede tardar unos minutos.',
  error_alert_title: 'Error al Subir',
  retry_button_label: 'Reintentar Cargar',
  start_recording_label: 'Empezar a Grabar',
  stop_recording_label: 'Para de Grabar',
  cancel_label: 'Cancelar'
};



// WEBPACK FOOTER //
// ./src/translations/es.js